import { memo, useCallback, useState } from "react";
import { Dropdown as BootstrapDropdown } from "react-bootstrap";

interface DropdownItemsProps {
  title: string;
  href: string;
}

interface DropdownProps {
  title?: string;
  items?: DropdownItemsProps[];
  href?: string;
}

const DEFAULT_TITLE = "Select";

const MENU_STYLE = {
  width: "250px",
  maxWidth: "250px",
  backdropFilter: "blur(2px)",
  backgroundColor: "rgba(195, 195, 195, 0.24)",
  whiteSpace: "normal" as const,
  wordWrap: "break-word" as const,
  overflowWrap: "break-word" as const,
  padding: "0.5rem",
  marginTop: "-5px",
} as const;

const ITEM_STYLE = {
  whiteSpace: "normal" as const,
  wordWrap: "break-word" as const,
  overflowWrap: "break-word" as const,
  padding: "0.25rem 0.5rem",
} as const;

interface DropdownItemRowProps {
  item: DropdownItemsProps;
}

const DropdownItemRow = memo(function DropdownItemRow({ item }: DropdownItemRowProps) {
  return (
    <BootstrapDropdown.Item
      as="a"
      className="nav-link rounded btn-bg"
      href={item.href}
      style={ITEM_STYLE}
    >
      {item.title}
    </BootstrapDropdown.Item>
  );
});

function Dropdown({ title = DEFAULT_TITLE, items = [], href }: DropdownProps) {
  const [show, setShow] = useState(false);

  const handleMouseEnter = useCallback(() => setShow(true), []);
  const handleMouseLeave = useCallback(() => setShow(false), []);

  return (
    <BootstrapDropdown
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      show={show}
    >
      <BootstrapDropdown.Toggle as="a" className="nav-link" href={href}>
        {title}
      </BootstrapDropdown.Toggle>
      <BootstrapDropdown.Menu style={MENU_STYLE}>
        {items.map((item) => (
          <DropdownItemRow key={item.href} item={item} />
        ))}
      </BootstrapDropdown.Menu>
    </BootstrapDropdown>
  );
}

Dropdown.displayName = "Dropdown";

export default memo(Dropdown);
